import {GetTypes} from "../../../helpers/enum-helpers";

export enum Steps {
  GeneralInformation = 1 << 0,
  LegalInformation = 1 << 1,
  TaxInformation = 1 << 2
}

export const StepsLabels: { [key: number]: string } = {
  [Steps.GeneralInformation]: "Allgemeine Informationen",
  [Steps.LegalInformation]: "Rechtliche Informationen",
  [Steps.TaxInformation]: "Steuerinformationen"
}

export const StepsList: Steps[] = GetTypes(Steps).map(x => parseInt(x));
